export type TimesMap = Record<string, string[]>;

const keyFor = (companyId: string | undefined, userId: string | undefined) => `tf:answer-times:${companyId || 'unknown'}:${userId || 'unknown'}`;

function safeParse<T>(raw: string | null): T | null {
  if (!raw) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function readTimes(companyId: string | undefined, userId: string | undefined): TimesMap {
  const raw = localStorage.getItem(keyFor(companyId, userId));
  return safeParse<TimesMap>(raw) || {};
}

export function writeTimes(companyId: string | undefined, userId: string | undefined, map: TimesMap): void {
  localStorage.setItem(keyFor(companyId, userId), JSON.stringify(map));
}

export function appendTime(companyId: string | undefined, userId: string | undefined, questionId: string, iso: string): void {
  const current = readTimes(companyId, userId);
  const existing = current[questionId] || [];
  current[questionId] = [...existing, iso];
  writeTimes(companyId, userId, current);
}

export function clearTimes(companyId: string | undefined, userId: string | undefined): void {
  localStorage.removeItem(keyFor(companyId, userId));
}

export function mergeTimes(base: TimesMap, overlay: TimesMap): TimesMap {
  const result: TimesMap = { ...base };
  Object.keys(overlay).forEach((k) => {
    const a = result[k] || [];
    const b = overlay[k] || [];
    // dedupe while preserving order: base first, then overlay extras
    const set = new Set<string>(a);
    const merged: string[] = [...a];
    b.forEach((t) => {
      if (!set.has(t)) {
        set.add(t);
        merged.push(t || '');
      }
    });
    result[k] = merged;
  });
  return result;
}
